/* eslint-disable */

// https://codesandbox.io/s/8l0m8qk0q0
// https://www.npmjs.com/package/vuex-rest-api
import vue from "vue";
import vuex from "vuex";
vue.use(vuex);

// 201906111259: https://vuex.vuejs.org/guide/modules.html
// 201906111324: https://github.com/christianmalek/vuex-rest-api/issues/58#issuecomment-378262432
import puntos from "./_punto";
import pilar from "./_pilar";
import reporte from "./_reporte";
import estrategia from "./_estrategia";
import linea from "./_linea";
import estado from "./_estado";
import producto from "./_producto";
import clasificaciones from "./_clasificacion";
import periodo from "./_periodo";
import barra from "./_barra";
import textos from "./_texto";
import opcion from "./_opcion";
import usuario from "./_usuario";
import tarea from "./_tarea";
import indicador from "./_indicador";
import unidad from "./_unidad";
import periodicidad from "./_periodicidad";
import meta from "./_meta";
import tipoacumulacion from "./_tipoacumulacion";
import tipoclasificador from "./_tipoclasificador";
import fechacorte from "./_fechacorte";
import campo from "./_campo";
import entidad from "./_entidad";
import sector from "./_sector";
import hito from "./_hito";
import auditoria from "./_auditoria";
import mensaje from "./_mensaje";
import semaforo from "./_semaforo";
import persona from "./_persona";
import navegacion from "./_navegacion";
import preguntafrecuente from "./_preguntafrecuente"
import avancecualitativo from "./_avancecualitativo";
import avancecuantitativo from "./_avancecuantitativo";
import soporte from "./_soporte";
import carga from "./_carga";
import configuracion from "./_configuracion";
import territorializacion from "./_territorializacion";
import tipoindicador from "./_tipoindicador";
import rol from "./_rol";
import fuente from "./_fuente";
import nacional from "./_nacional";
import nacionalformulacion from "./_nacionalformulacion";
import cuestionario from "./_cuestionario";
import tipopregunta from "./_tipopregunta";
import actividadavance from "./_actividadavance";
import avancenacional from "./_avancenacional";
import estrategianacional from "./_estrategianacional";
import financiamientoavance from "./_financiamientoavance";
import controlpresentacion from "./_controlpresentacion";
import respuesta from "./_respuesta";
import financiamiento from "./_financiamiento";
import plannacionaldesarrollo from "./_plannacionaldesarrollo";
import nivelpnd from "./_nivelpnd";
import indicadorpnd from "./_indicadorpnd";
import fichatecnica from "./_fichatecnica";
import presupuesto from "./_presupuesto";
import recursos from "./_recursos";
import temporizador from "./_temporizador";
import acciontiempo from "./_acciontiempo";
import recursobasefuncionamiento from "./_recursobasefuncionamiento";
import recursomarcofiscal from "./_recursomarcofiscal";
import recursocifras from "./_recursocifras";
import recursoplurianual from "./_recursoplurianual";
import plurianual from "./_plurianual";
import proceso from "./_proceso";
import util from "./_util";
import subregion from "./_subregion";
import departamento from "./_departamento";
import municipio from "./_municipio";
import proyectopdet from "./_proyectopdet";
import iniciativapdet from "./_iniciativapdet";
import geometas from "./_geometas";
import desagregacionpoblacional from "./_desagregacionpoblacional";
import reestriccion from "./_reestriccion";
import TipovalorListadesagregacion from "./_tipovalorListadesagregacion"
import indicadortipovalor from "./_indicadortipovalor"
import listadesagregaciones from "./_listadesagregaciones"
import PNDJson from "./_PNDJson"
import comentarios from "./_comentario"
import metodologias from "./_metodologia"
import orientaciones from "./_orientacion"
import Series from "./_serie"
import controlproceso from "./_controlproceso";

const store = new vuex.Store({
    modules: {
        puntos,
        reporte,
        clasificaciones,
        periodo,
        barra,
        textos,
        opcion,
        usuario,
        pilar,
        estrategia,
        linea,
        producto,
        tarea,
        indicador,
        unidad,
        periodicidad,
        meta,
        preguntafrecuente,
        tipoacumulacion,
        campo,
        entidad,
        sector,
        mensaje,
        hito,
        semaforo,
        persona,
        tipoclasificador,
        navegacion,
        avancecualitativo,
        avancecuantitativo,
        soporte,
        territorializacion,
        tipoindicador,
        rol,
        estado,
        configuracion,
        auditoria,
        fechacorte,
        fuente,
        nacional,
        carga,
        nacionalformulacion,
        cuestionario,
        tipopregunta,
        actividadavance,
        avancenacional,
        estrategianacional,
        financiamientoavance,
        controlpresentacion,
        respuesta,
        financiamiento,
        plannacionaldesarrollo,
        nivelpnd,
        indicadorpnd,
        fichatecnica,
        presupuesto,
        recursos,
        temporizador,
        acciontiempo,
        recursobasefuncionamiento,
        recursomarcofiscal,
        recursocifras,
        recursoplurianual,
        plurianual,
        proceso,
        util,
        subregion,
        departamento,
        municipio,
        proyectopdet,
        iniciativapdet,
        geometas,
        desagregacionpoblacional,
        reestriccion,
        TipovalorListadesagregacion,
        indicadortipovalor,
        listadesagregaciones,
        PNDJson,
        comentarios,
        metodologias,
        orientaciones,
        Series,
        controlproceso
    }
});

export default store;